<template>
  <FormModal
    v-if="data"
    title="Edit Site Custom Style"
    method="PUT"
    :endpoint="`partners/${partner_id}/sites/${site_id}/custom-styles/${custom_style_id}`"
    :data="data"
    v-bind="$attrs"
    size="wide"
    @success="success"
  >
    <Alert type="info" class="mb-8"
      >When enabling/disabling a custom style, the cache will be cleared for the site but the changes may not be
      immediately visible when using the CDN.</Alert
    >

    <InputGroup label="Target" name="target" description="Which script should this custom style be included with.">
      <Select v-model="data.target" endpoint="options/script-names" prepend-option="All Scripts" disabled />
    </InputGroup>

    <InputGroup label="Description" name="description" description="Describe what this custom style does/is for.">
      <TextInput v-model="data.description" />
    </InputGroup>

    <InputGroup
      label="Custom Style(s)"
      name="content"
      description="The custom style(s). Example: .selector { color: red; }"
    >
      <TextInput v-model="data.content" textarea :rows="20" />
      <Button prepend-icon="magic" class="mt-2" @click="checkStyles()">Check styles</Button>
    </InputGroup>

    <InputGroup label="Enabled" name="enabled">
      <ToggleSwitch v-model="data.enabled" label="Enable this custom style" />
    </InputGroup>
  </FormModal>
</template>

<script>
import CheckScriptStyleMixin from "./CheckScriptStyleMixin"

export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    site_id: {
      type: Number,
      required: true
    },
    custom_style_id: {
      type: Number,
      required: true
    }
  },
  mixins: [CheckScriptStyleMixin],
  data: () => ({
    data: {
      target: null,
      description: "",
      content: "",
      enabled: true
    }
  }),
  async mounted() {
    let response = await this.$api.get(
      `partners/${this.partner_id}/sites/${this.site_id}/custom-styles/${this.custom_style_id}`
    )
    this.data = response.data.data
    this.data.target = "copilot"
    this.loading = false
  },
  methods: {
    success(result) {
      this.$notification.success(`Custom style successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
